import {
    CLEAR_ATTENDENCE, CLEAR_ATTENDENCE_FILTER,
    GET_ATTENDENCE, GET_ATTENDENCE_FAILURE,
    GET_ATTENDENCE_PROPERTIES, GET_ATTENDENCE_PROPERTIES_FAILURE, GET_ATTENDENCE_PROPERTIES_SUCCESS,
    GET_ATTENDENCE_SCHEDULES, GET_ATTENDENCE_SCHEDULES_FAILURE, GET_ATTENDENCE_SCHEDULES_SUCCESS,
    GET_ATTENDENCE_SUCCESS,
    GET_ATTENDENCE_USERS, GET_ATTENDENCE_USERS_FAILURE, GET_ATTENDENCE_USERS_SUCCESS,
    GET_SIDEBAR_USERS, GET_SIDEBAR_USERS_SUCCESS, GET_SIDEBAR_USERS_FAILURE,
    GET_ATTENDENCE_BY_USER,
    APPROVE_ATTENDANCE, APPROVE_ATTENDANCE_SUCCESS, APPROVE_ATTENDANCE_FAILURE,
} from "../constants";

const initialState = {
    loader: false,
    attendenceData: [],
    propertiesData: [],
    usersData: [],
    schedulesData: [],
    sidebarUsersData: [],       // v2: users list for sidebar
    sidebarUsersLoader: false,  // v2
    attendenceError: false,
    sidebarUsersError: false,
}

export default function AttendenceManagementReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ATTENDENCE:
            state = {
                ...state,
                loader: true,
                sidebarUsersLoader: true,
            }
            break;

        case GET_ATTENDENCE_SUCCESS: {
            const data = action.payload?.data || [];
            const filters = action.filters || {};
            let usersData = [];
            let hasUsersInPayload = false;

            if (action.payload?.users && Array.isArray(action.payload.users)) {
                usersData = action.payload.users.map((u) => ({
                    label: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.userName || 'Unknown User',
                    value: u.id,
                    profileImg: u.profileImg?.[0]?.url || u.profileImg || null,
                    hasWarning: false,
                }));
                hasUsersInPayload = true;
            } else if (action.payload?.meta?.users && Array.isArray(action.payload.meta.users)) {
                usersData = action.payload.meta.users.map((u) => ({
                    label: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.userName || 'Unknown User',
                    value: u.id,
                    profileImg: u.profileImg?.[0]?.url || u.profileImg || null,
                    hasWarning: false,
                }));
                hasUsersInPayload = true;
            } else {
                // Extract unique users from data
                const usersMap = {};
                data.forEach((rec) => {
                    const u = rec?.user;
                    if (u && u.id) {
                        if (!usersMap[u.id]) {
                            usersMap[u.id] = {
                                label: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.userName || 'Unknown User',
                                value: u.id,
                                profileImg: u.profileImg?.[0]?.url || u.profileImg || null,
                                hasWarning: false,
                            };
                        }
                        if (rec.checkIn && !rec.checkOut) {
                            usersMap[u.id].hasWarning = true;
                        }
                    }
                });
                usersData = Object.values(usersMap);
            }

            // Only update sidebarUsersData if:
            // 1. A property or schedule filter is active (to show only matching users),
            //    AND (we have explicit users in payload, or no userId filter was applied).
            const shouldUpdateSidebar = (filters.propertyId || filters.scheduleId) && (hasUsersInPayload || !filters.userId);
            const updatedSidebarUsersData = shouldUpdateSidebar
                ? usersData
                : state.sidebarUsersData;

            state = {
                ...state,
                loader: false,
                sidebarUsersLoader: false,
                attendenceData: data,
                paginate: action.payload?.paginate || null,
                meta: action.payload?.meta || null,
                sidebarUsersData: updatedSidebarUsersData,
                attendenceError: false,
            }
            break;
        }

        case GET_ATTENDENCE_FAILURE:
            state = {
                ...state,
                loader: false,
                sidebarUsersLoader: false,
                attendenceData: action.payload ? [] : state.attendenceData,
                attendenceError: !!action.payload,
            }
            break;

        case GET_ATTENDENCE_PROPERTIES:
            state = {
                ...state,
            }
            break;

        case GET_ATTENDENCE_PROPERTIES_SUCCESS:
            state = {
                ...state,
                propertiesData: action.payload,
                usersData: []
            }
            break;

        case GET_ATTENDENCE_PROPERTIES_FAILURE:
            state = {
                ...state,
            }
            break;
        case GET_ATTENDENCE_SCHEDULES:
            state = {
                ...state,
            }
            break;
        case GET_ATTENDENCE_SCHEDULES_SUCCESS:
            state = {
                ...state,
                schedulesData: action.payload
            }
            break;
        case GET_ATTENDENCE_SCHEDULES_FAILURE:
            state = {
                ...state,
            }
            break;
        case GET_ATTENDENCE_USERS:
            state = {
                ...state,
            }
            break;
        case GET_ATTENDENCE_USERS_SUCCESS:
            state = {
                ...state,
                usersData: action.payload
            }
            break;
        case GET_ATTENDENCE_USERS_FAILURE:
            state = {
                ...state,
            }
            break;
        case CLEAR_ATTENDENCE_FILTER:
            state = {
                ...state,
                propertiesData: [],
                usersData: [],
                schedulesData: []
            }
            break;
        case CLEAR_ATTENDENCE:
            state = {
                ...state,
                propertiesData: [],
                usersData: [],
                schedulesData: [],
                attendenceData: [],
                sidebarUsersData: [],
                sidebarUsersLoader: false,
            }
            break;

        // v2 cases
        case GET_SIDEBAR_USERS:
            state = { ...state, sidebarUsersLoader: true }
            break;
        case GET_SIDEBAR_USERS_SUCCESS:
            state = {
                ...state,
                sidebarUsersLoader: false,
                sidebarUsersData: action.payload?.paginate?.currentPage > 1
                    ? [...state.sidebarUsersData, ...action.payload.usersData]
                    : action.payload.usersData,
                sidebarUsersPaginate: action.payload?.paginate,
                sidebarUsersError: false,
            }
            break;
        case GET_SIDEBAR_USERS_FAILURE:
            state = {
                ...state,
                sidebarUsersLoader: false,
                sidebarUsersData: action.payload ? [] : state.sidebarUsersData,
                sidebarUsersError: !!action.payload,
            }
            break;

        case GET_ATTENDENCE_BY_USER:
            state = { ...state, loader: true }
            break;

        // Attendance Approval
        case APPROVE_ATTENDANCE:
            state = { ...state, approving: true };
            break;

        case APPROVE_ATTENDANCE_SUCCESS: {
            const updatedItems = action.payload?.items;
            let updatedAttendenceData = state.attendenceData;
            if (Array.isArray(updatedItems) && updatedItems.length > 0) {
                // Build a lookup map from the returned updated records
                const updatedMap = {};
                updatedItems.forEach((item) => {
                    const key = item.shiftUserId || item.id;
                    if (key) updatedMap[key] = item;
                });
                // Merge updated records into existing list
                updatedAttendenceData = state.attendenceData.map((rec) => {
                    const key = rec.shiftUserId || rec.id;
                    return updatedMap[key] ? { ...rec, ...updatedMap[key] } : rec;
                });
            }
            state = { ...state, approving: false, attendenceData: updatedAttendenceData };
            break;
        }

        case APPROVE_ATTENDANCE_FAILURE:
            state = { ...state, approving: false };
            break;

        default:
            break;
    }
    return state
}